
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 3.334c-9.19 0-16.666 7.477-16.666 16.667v6.905C3.334 28.612 4.829 30 6.667 30h1.667a1.667 1.667 0 001.667-1.667v-8.572a1.667 1.667 0 00-1.667-1.666H6.821C7.747 11.646 13.297 6.667 20 6.667c6.703 0 12.253 4.979 13.18 11.429h-1.514a1.667 1.667 0 00-1.666 1.666v10.239a3.337 3.337 0 01-3.334 3.333h-3.333v-1.667h-6.667v5h10a6.673 6.673 0 006.667-6.666c1.838 0 3.333-1.389 3.333-3.095V20c0-9.19-7.476-16.667-16.666-16.667z","fill":"#fff","fill-opacity":".5"}})])
          )
        }
      }
    